export const Colors = {
  Primary: "#a1cada",
  Green: "#45bd4d",
} as const;
